import type { NavigateFunction } from 'react-router-dom';
import { LAUNCH_NAV_SCROLL_MAP } from '../constants';

export function getLaunchSectionHash(href: string): string {
  if (href.startsWith('#')) return href;
  return LAUNCH_NAV_SCROLL_MAP[href] ?? '#accueil';
}

/** Depuis une autre route (ex. fiche projet), renvoie vers `/` puis la section vitrine. */
export function navigateToLaunchSection(
  navigate: NavigateFunction,
  pathname: string,
  href: string,
): void {
  const hash = getLaunchSectionHash(href);
  if (pathname !== '/') {
    navigate({ pathname: '/', hash: hash.replace(/^#/, '') });
    return;
  }
  scrollToLaunchSection(href);
}

export function scrollToLaunchSection(href: string) {
  const hash = getLaunchSectionHash(href);
  const el = document.querySelector(hash);
  if (!(el instanceof HTMLElement)) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }

  const sectionTop = el.getBoundingClientRect().top + window.scrollY;
  const centered = sectionTop - (window.innerHeight - el.offsetHeight) / 2;
  const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);

  window.scrollTo({
    top: Math.min(Math.max(0, centered), maxScroll),
    behavior: 'smooth',
  });
}
